import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import type { GuardHit } from '@/lib/contentGuard';

export function ContentGuardWarning({ hits }: { hits: GuardHit[] }) {
  const { t } = useTranslation('common');
  if (hits.length === 0) return null;
  const banned = hits.filter((h) => h.severity === 'banned');
  const retired = hits.filter((h) => h.severity === 'retired');
  return (
    <div
      role="status"
      className="mt-1 rounded-[var(--radius-md)] border border-[color:var(--color-warn)] bg-[color:var(--color-warn-soft)] p-3 text-xs text-[color:var(--color-fg)]"
    >
      <div className="flex items-start gap-2">
        <AlertTriangle aria-hidden className="mt-0.5 size-4 shrink-0 text-[color:var(--color-warn)]" />
        <div className="space-y-1">
          {banned.length > 0 ? (
            <p>
              <strong className="font-semibold">{t('guard.bannedTitle')}</strong>{' '}
              {t('guard.bannedBody', { terms: Array.from(new Set(banned.map((h) => h.term))).join(', ') })}
            </p>
          ) : null}
          {retired.length > 0 ? (
            <p>
              <strong className="font-semibold">{t('guard.retiredTitle')}</strong>{' '}
              {t('guard.retiredBody', { terms: Array.from(new Set(retired.map((h) => h.term))).join(', ') })}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
